import { ledgerEndPoints } from "../constants/endpoints";
import { LedgerResponseType } from "../constants/types";
import { api } from "./api";
import { getApiOrganizationId } from "../utils/orgIdUtils";

type UpdateType = {
  credit: string;
  orderId?: string;
  customerId: string;
  id?: string;
};

export const updateLedger = async (data: UpdateType) => {
  try {
    return await api.put(ledgerEndPoints.base, data, {
      headers: {
        orgId: getApiOrganizationId(),
      },
    });
  } catch (error) {
    throw new Error("Failed to create or update ledger");
  }
};

export const deleteLedger = async (id: string) => {
  try {
    return await api.delete(`${ledgerEndPoints.base}/${id}`, {
      headers: {
        orgId: getApiOrganizationId(),
      },
    });
  } catch (error) {
    throw new Error("Failed to delete ledger entry");
  }
};

export const getLedgerList = async (queryParams: Record<string, string>) => {
  try {
    const queryString = new URLSearchParams(queryParams).toString();

    const response = await api.get(`${ledgerEndPoints.base}?${queryString}`, {
      headers: {
        orgId: getApiOrganizationId(),
      },
    });

    return response.data.data.response as LedgerResponseType;
  } catch (error) {
    throw new Error("Failed to fetch ledger list");
  }
};

export const downloadLedger = async (data: Record<string, string>) => {
  try {
    const queryString = new URLSearchParams(data).toString();

    const response = await api.get(
      `${ledgerEndPoints.download}?${queryString}`,
      {
        headers: {
          orgId: getApiOrganizationId(),
        },
      }
    );

    return response.data.data as LedgerResponseType;
  } catch (error) {
    throw new Error("Failed to download ledger");
  }
};
